/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Plane16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray}
            fillRule="evenodd"
            d="M14.321 1.034a.5.5 0 01.67.565l-.024.08-5 13a.5.5 0 01-.905.063l-.036-.084-1.92-5.763-5.763-1.92a.501.501 0 01-.174-.85l.075-.055.077-.036 13-5zM13.19 3.517L8.072 8.634l1.463 4.384 3.654-9.5zm-.71-.705L2.983 6.466l4.383 1.461 5.115-5.115z"
        />
    </AccessibleSVG>
);

export default Plane16;
